import mixpanel from "mixpanel-browser";
import { useEffect, useRef } from "react";
import { CalendarDay, PrayerHour } from "../calendar/utils";
import { getDayString } from "./date-utils";
import { useSettings } from "./settings";

export const useTrackPray = (day: CalendarDay, hour: PrayerHour) => {
    const { settings } = useSettings();

    const timeoutRef = useRef<NodeJS.Timeout>(setTimeout(() => {}, 0));
    const tracked = useRef(false);
    useEffect(() => {
        timeoutRef.current = setTimeout(() => {
            if (!tracked.current) {
                window.localStorage.setItem(`last-${hour}`, getDayString(day));

                tracked.current = true;
                mixpanel.track("pray", { ...day, hour, ...settings });
            }
        }, 300000);

        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, []);
};
